import caymaFormuBlocks from './legal-raw/cayma-formu.json';
import iptalIadeBlocks from './legal-raw/iptal-iade.json';
import kullanimSozlesmesiBlocks from './legal-raw/kullanim-sozlesmesi.json';
import kvkkBlocks from './legal-raw/kvkk.json';
import mesafeliSatisBlocks from './legal-raw/mesafeli-satis.json';
import type { LegalBlock, LegalDocumentMeta } from '../types/legal';

export const legalDocuments: LegalDocumentMeta[] = [
  {
    slug: 'kvkk-aydinlatma-metni',
    title: 'KVKK Aydınlatma Metni',
    description:
      'Health Shop Longevity web sitesi gizlilik sözleşmesi ve kişisel verilerin korunmasına ilişkin aydınlatma metni.',
    blocks: kvkkBlocks as LegalBlock[],
  },
  {
    slug: 'kullanim-sozlesmesi',
    title: 'Web Sitesi Kullanım Sözleşmesi',
    description:
      'Health Shop Longevity internet sitesinin kullanım koşullarını düzenleyen sözleşme metni.',
    blocks: kullanimSozlesmesiBlocks as LegalBlock[],
  },
  {
    slug: 'mesafeli-satis-sozlesmesi',
    title: 'Mesafeli Satış Sözleşmesi',
    description:
      '6502 sayılı Tüketicinin Korunması Hakkında Kanun kapsamında mesafeli satış sözleşmesi.',
    blocks: mesafeliSatisBlocks as LegalBlock[],
  },
  {
    slug: 'iptal-iade-kosullari',
    title: 'Cayma – İptal ve İade Koşulları',
    description:
      'Sipariş iptali, cayma hakkı ve ürün iade süreçlerine ilişkin koşullar.',
    blocks: iptalIadeBlocks as LegalBlock[],
  },
  {
    slug: 'cayma-formu',
    title: 'Cayma Formu',
    description:
      'Mesafeli satış sözleşmesinden cayma hakkını kullanmak için doldurulacak form.',
    blocks: caymaFormuBlocks as LegalBlock[],
  },
];

export function getLegalDocument(slug: string) {
  return legalDocuments.find((doc) => doc.slug === slug);
}

export const legalNavLinks = legalDocuments.map(({ slug, title }) => ({
  slug,
  title,
  path: `/yasal/${slug}`,
}));
